import React from 'react';

// eslint-disable-next-line react/display-name
export default () => {
    return (
        <div className="container">
            <h1 className="display-4" style={{ marginTop: 100 }}>
                <span className="text-danger">500</span> Application Error
            </h1>
            <p className="lead"> Sorry, Application Error. Please Try After Sometime </p>
        </div>
    );
};
